import { Injectable } from '@angular/core';

import { LocalStoreService } from '@frontend/vanilla/core';

export interface StorageItem<T> {
    data: T;
    timestamp: number;
}

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    constructor(private localStore: LocalStoreService) {}

    getItem<T>(storageKey: string): T[] {
        const y = this.localStore.get<T[]>(storageKey) || [];

        return y;
    }

    getItemObject<T>(storageKey: string): T | null {
        return this.localStore.get<T>(storageKey);
    }

    saveItem<T>(storageKey: string, input: T): void {
        if (!input) {
            return;
        }

        this.localStore.set<T>(storageKey, input);
    }

    clearStorage(storageKey: string): void {
        this.localStore.remove(storageKey);
    }

    addTimestampToItem<T>(item: T): StorageItem<T> {
        const timestamp = new Date().getTime();

        return { data: item, timestamp } as StorageItem<T>;
    }

    sortStorageItemsByTimestamp<T>(items: StorageItem<T>[]): StorageItem<T>[] {
        return items.sort((a, b) => b.timestamp - a.timestamp);
    }

    clearExpiredItems<T>(expirationDays: number, storageKey: string): void {
        const storedItems: StorageItem<T>[] = this.getItem<StorageItem<T>>(storageKey);
        const currentTime = new Date().getTime();
        let hasItemRemoved = false;

        if (storedItems.length) {
            const filteredArray = storedItems.filter((item) => {
                if (!item?.timestamp) {
                    hasItemRemoved = true;

                    return false;
                }
                const millisecondsInOneDay: number = 1000 * 60 * 60 * 24;
                const daysDifference: number = Math.floor((currentTime - item.timestamp) / millisecondsInOneDay);

                if (daysDifference >= expirationDays) {
                    hasItemRemoved = true;

                    return false;
                }

                return true;
            });

            if (hasItemRemoved) {
                this.saveItem<StorageItem<T>[]>(storageKey, filteredArray);
            }
        }
    }
}
